import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWarningFullOrange = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    aria-label="Warning_full_orange"
    viewBox="0 0 20 20"
    {...props}
  >
    <g className="Warning_full_orange_svg__Icons/warning Warning_full_orange_svg__full Warning_full_orange_svg__orange">
      <g className="Warning_full_orange_svg__Group Warning_full_orange_svg__1261153670">
        <circle
          cx={10}
          cy={10}
          r={8}
          fill="url(#Warning_full_orange_svg__a)"
          className="Warning_full_orange_svg__Ellipse Warning_full_orange_svg__1934"
        />
        <path
          fill="#fff"
          d="M11 13.4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1.8-3a.8.8 0 0 0 1.6 0V6a.8.8 0 0 0-1.6 0z"
          className="Warning_full_orange_svg__Vector"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="Warning_full_orange_svg__a"
        x1={15}
        x2={-5}
        y1={13.75}
        y2={13.333}
        className="Warning_full_orange_svg__a"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F19325" />
        <stop offset={1} stopColor="#FAD2A4" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgWarningFullOrange;
